export const COMMON_ERROR_NOTICE = 'We have experienced an issue, please try again later.';
export const PLAN_IS_NOT_VALID_ERROR_NOTICE = 'Billing plan is not valid for this action.';
export const ZOOM_ACCOUNT_ERROR_NOTICE = 'Zoom account has not been connected.';
export const EVENT_BOOKED_SUCCESSFULLY_NOTICE = 'Event has been booked successfully.';